export class EquipmentMoveModel {
    
    constructor(cellNumber?: string, serialNumbers?: string[]){
        this.cellNumber = cellNumber;
        this.serialNumbers = serialNumbers;
    }

    cellNumber?: string;
    serialNumbers?: string[] = [];
}